import { render, staticRenderFns } from "./QuestionTip.vue?vue&type=template&id=01a5e3d6&scoped=true"
import script from "./QuestionTip.vue?vue&type=script&lang=js"
export * from "./QuestionTip.vue?vue&type=script&lang=js"
import style0 from "./QuestionTip.vue?vue&type=style&index=0&id=01a5e3d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a5e3d6",
  null
  
)

export default component.exports